import { tabFocusToggleKeys } from '#choo-app/lib/editor/plugins/focus-lock'
import {
  buildShortcutTip,
  detectedPlatform,
  Keys,
  Platform,
} from '#hooks/useShortcuts'

const { CMD, ENTER, SHIFT, TAB, ALT } = Keys

type ModalShortcuts = {
  navigation: JSONValue
  formatting: JSONValue
}

export const modalShortcuts = (
  platform: Platform = detectedPlatform,
): ModalShortcuts => {
  return {
    navigation: {
      'Create a new block': buildShortcutTip([ENTER], platform),
      'Cycle through element types': buildShortcutTip([TAB], platform),
      'Cycle through element types backward': buildShortcutTip(
        [SHIFT, TAB],
        platform,
      ),
      'Open element menu': buildShortcutTip([CMD, '\\'], platform),
      'Open timing menu': buildShortcutTip([CMD, SHIFT, '0'], platform),
      'Exclude from timing': buildShortcutTip([CMD, SHIFT, 'X'], platform),
      'Push to prompter': buildShortcutTip([CMD, SHIFT, 'P'], platform),
      'Insert page break': buildShortcutTip([CMD, ENTER], platform),
      'Toggle whether Tab moves focus': buildShortcutTip(
        tabFocusToggleKeys(platform),
        platform,
      ),
    },
    formatting: {
      // repeat of the constants above to allow overriding the detected platform
      Bold: buildShortcutTip([CMD, 'B'], platform),
      Italic: buildShortcutTip([CMD, 'I'], platform),
      Underline: buildShortcutTip([CMD, 'U'], platform),
      Strikethrough: buildShortcutTip([CMD, SHIFT, 'U'], platform),
      Caps: buildShortcutTip([CMD, ALT, 'A'], platform),
    },
  }
}
